import { jsx, jsxs } from 'react/jsx-runtime';
import { DialogOverlay as DialogOverlay$1, DialogPortal as DialogPortal$1, Content as DialogContent$1, DialogTitle as DialogTitle$1, Description as DialogDescription$1, Dialog as Dialog$1, DialogTrigger as DialogTrigger$1, Close as DialogClose$1 } from '../../vendor/@radix-ui/react-dialog/dist/index.mjs';
import * as React from 'react';
import { cn } from '../../lib/utils.js';

const Dialog = Dialog$1;
const DialogTrigger = DialogTrigger$1;
const DialogPortal = DialogPortal$1;
const DialogClose = DialogClose$1;
const DialogOverlay = React.forwardRef(({ className, ...props }, ref) => /* @__PURE__ */ jsx(
  DialogOverlay$1,
  {
    ref,
    className: cn(
      "dialog-overlay fixed inset-0 z-[999999] bg-dim-black-opacity-60 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0",
      className
    ),
    ...props
  }
));
DialogOverlay.displayName = DialogOverlay$1.displayName;
const DialogContent = React.forwardRef(({ className, children, ...props }, ref) => {
  const contentRef = React.useRef(null);
  const setRefs = React.useCallback(
    (node) => {
      contentRef.current = node;
      if (typeof ref === "function") {
        ref(node);
      } else if (ref) {
        ref.current = node;
      }
    },
    [ref]
  );
  return /* @__PURE__ */ jsxs(DialogPortal, { children: [
    /* @__PURE__ */ jsx(DialogOverlay, {}),
    /* @__PURE__ */ jsx(
      DialogContent$1,
      {
        ref: setRefs,
        onOpenAutoFocus: (e) => {
          e.preventDefault();
          contentRef?.current?.focus();
        },
        className: cn(
          "dialog-content fixed left-[50%] top-[50%] z-[999999] w-full translate-x-[-50%] overflow-hidden translate-y-[-50%] bg-base-white duration-200 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[state=closed]:slide-out-to-left-1/2 data-[state=closed]:slide-out-to-top-[48%] data-[state=open]:slide-in-from-left-1/2 data-[state=open]:slide-in-from-top-[48%] rounded-2xl outline-none focus:outline-none",
          className
        ),
        ...props,
        children
      }
    )
  ] });
});
DialogContent.displayName = DialogContent$1.displayName;
const DialogContentWithoutOverlay = React.forwardRef(({ className, children, ...props }, ref) => /* @__PURE__ */ jsx(DialogPortal, { children: /* @__PURE__ */ jsx(
  DialogContent$1,
  {
    ref,
    className: cn(
      "fixed left-[50%] top-[50%] z-50 w-full translate-x-[-50%] overflow-hidden translate-y-[-50%] border bg-base-white shadow-lg duration-200 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[state=closed]:slide-out-to-left-1/2 data-[state=closed]:slide-out-to-top-[48%] data-[state=open]:slide-in-from-left-1/2 data-[state=open]:slide-in-from-top-[48%] rounded-2xl",
      className
    ),
    ...props,
    children
  }
) }));
DialogContentWithoutOverlay.displayName = "DialogContentWithoutOverlay";
const DialogHeader = ({ className, ...props }) => /* @__PURE__ */ jsx(
  "div",
  {
    className: cn(
      "w-full inline-flex justify-start md:justify-center items-center px-12 py-4 border-b border-basic-04 h-[58px]",
      className
    ),
    ...props
  }
);
DialogHeader.displayName = "DialogHeader";
const DialogFooter = ({ className, ...props }) => /* @__PURE__ */ jsx("div", { className: cn("w-full absolute bottom-0 left-0 backdrop-blur-sm", className), ...props });
DialogFooter.displayName = "DialogFooter";
const DialogTitle = React.forwardRef(({ className, ...props }, ref) => /* @__PURE__ */ jsx(
  DialogTitle$1,
  {
    ref,
    className: cn("heading-h5 font-weight-medium text-basic-01", className),
    ...props
  }
));
DialogTitle.displayName = DialogTitle$1.displayName;
const DialogDescription = React.forwardRef(({ className, ...props }, ref) => /* @__PURE__ */ jsx(DialogDescription$1, { ref, className: cn(" text-basic-01", className), ...props }));
DialogDescription.displayName = DialogDescription$1.displayName;

export { Dialog, DialogClose, DialogContent, DialogContentWithoutOverlay, DialogDescription, DialogFooter, DialogHeader, DialogOverlay, DialogPortal, DialogTitle, DialogTrigger };
